import(/* webpackMode: "eager" */ "/vercel/path0/src/app/daily-lottery/page.tsx");
